/**
 * Mapeo de IDs de campos a códigos de traducción para las explicaciones/tooltips
 * Los textos reales estarán en los archivos de traducciones (es.json, en.json, etc.)
 * 
 * Formato: fieldId -> código de traducción
 * Ejemplo: 'account_id' -> 'field_descriptions.account_id'
 * 
 * Nota: Los IDs pueden venir en diferentes formatos (ej: 'clicks', 'FIELD_CLICKS', 'CLICKS')
 * Se deben agregar todas las variantes posibles aquí.
 */
export const FIELD_DESCRIPTIONS = {
    // Dimensiones - Cuenta
    'account_currency': 'field_descriptions.account_currency',
    'account_id': 'field_descriptions.account_id',
    'account_timezone': 'field_descriptions.account_timezone',
    'FIELD_ACCOUNT_CURRENCY': 'field_descriptions.account_currency',
    'FIELD_ACCOUNT_ID': 'field_descriptions.account_id',
    'FIELD_ACCOUNT_TIMEZONE': 'field_descriptions.account_timezone',
    
    // Dimensiones - Campaña
    'campaign_id': 'field_descriptions.campaign_id',
    'campaign': 'field_descriptions.campaign',
    'FIELD_CAMPAIGN_ID': 'field_descriptions.campaign_id',
    'FIELD_CAMPAIGN': 'field_descriptions.campaign',
    
    // Dimensiones - Performance
    'day': 'field_descriptions.day',
    'FIELD_DAY': 'field_descriptions.day',
    
    // Métricas básicas
    'ctr': 'field_descriptions.ctr',
    'impressions': 'field_descriptions.impressions',
    'clicks': 'field_descriptions.clicks',
    'FIELD_CTR': 'field_descriptions.ctr',
    'FIELD_IMPRESSIONS': 'field_descriptions.impressions',
    'FIELD_CLICKS': 'field_descriptions.clicks',
    'meta_ads_hook_rate': 'field_descriptions.meta_ads_hook_rate',
    'FIELD_META_ADS_HOOK_RATE': 'field_descriptions.meta_ads_hook_rate',
    
    // Métricas de Conversiones y CPA - Variantes posibles
    'cpa_primary_conversions': 'field_descriptions.cpa_primary_conversions',
    'CPA_PRIMARY_CONVERSIONS': 'field_descriptions.cpa_primary_conversions',
    'FIELD_CPA_PRIMARY_CONVERSIONS': 'field_descriptions.cpa_primary_conversions',
    'CPA_Conversiones_primarias': 'field_descriptions.cpa_primary_conversions',
    
    'primary_conversions': 'field_descriptions.primary_conversions',
    'PRIMARY_CONVERSIONS': 'field_descriptions.primary_conversions',
    'FIELD_PRIMARY_CONVERSIONS': 'field_descriptions.primary_conversions',
    'Conversiones_Primarias': 'field_descriptions.primary_conversions',
    
    'selected_events_conversions': 'field_descriptions.selected_events_conversions',
    'SELECTED_EVENTS_CONVERSIONS': 'field_descriptions.selected_events_conversions',
    'FIELD_SELECTED_EVENTS_CONVERSIONS': 'field_descriptions.selected_events_conversions',
    'Conversiones_de_Eventos_seleccionados': 'field_descriptions.selected_events_conversions',
    
    'cpa_selected_events': 'field_descriptions.cpa_selected_events',
    'CPA_SELECTED_EVENTS': 'field_descriptions.cpa_selected_events',
    'FIELD_CPA_SELECTED_EVENTS': 'field_descriptions.cpa_selected_events',
    'CPA_Eventos_seleccionados': 'field_descriptions.cpa_selected_events',
    
    // Presupuestos - Variantes posibles
    'business_unit_budget': 'field_descriptions.business_unit_budget',
    'BUSINESS_UNIT_BUDGET': 'field_descriptions.business_unit_budget',
    'FIELD_BUSINESS_UNIT_BUDGET': 'field_descriptions.business_unit_budget',
    'Presupuesto_de_línea_de_control': 'field_descriptions.business_unit_budget',
    'Presupuesto_de_linea_de_control': 'field_descriptions.business_unit_budget',
    
    'campaign_budget': 'field_descriptions.campaign_budget',
    'CAMPAIGN_BUDGET': 'field_descriptions.campaign_budget',
    'FIELD_CAMPAIGN_BUDGET': 'field_descriptions.campaign_budget',
    'Presupuesto_de_Campaña_de_línea_de_control': 'field_descriptions.campaign_budget',
    'Presupuesto_de_Campana_de_linea_de_control': 'field_descriptions.campaign_budget',
    
    'adgroup_budget': 'field_descriptions.adgroup_budget',
    'ADGROUP_BUDGET': 'field_descriptions.adgroup_budget',
    'FIELD_ADGROUP_BUDGET': 'field_descriptions.adgroup_budget',
    'Presupuesto_de_Grupo_de_anuncios_de_línea_de_control': 'field_descriptions.adgroup_budget',
    'Presupuesto_de_Grupo_de_anuncios_de_linea_de_control': 'field_descriptions.adgroup_budget',
    
    // Agregar más campos según sea necesario
};

/**
 * Obtiene el código de traducción para un campo dado su ID
 * @param {string} fieldId - ID del campo
 * @returns {string|null} - Código de traducción o null si no existe explicación
 */
export function getFieldDescriptionKey(fieldId) {
    return FIELD_DESCRIPTIONS[fieldId] || null;
}

/**
 * Verifica si un campo tiene explicación disponible
 * @param {string} fieldId - ID del campo
 * @returns {boolean} - true si tiene explicación, false en caso contrario
 */
export function hasFieldDescription(fieldId) {
    return fieldId in FIELD_DESCRIPTIONS;
}

